import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.hr.afamksa.com',
});

api.interceptors.request.use(
  (config) => {
    // This MUST be inside the interceptor to get the LATEST token
    const token = localStorage.getItem('token'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;